import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { collection, getDocs } from 'firebase/firestore';
import { auth, db } from '../../firebase';

import SEO from '../SEO';
import Popup from '../Popup';
import Loading from '../Loading';
import MyPageMenu from './MyPageMenu';
import DeleteSelected from './DeleteSelected'; // 추가
import ActTags from './ActTags';
import PushPopup from './PushPopup'; // PushAlbumPopup 대신 제너럴 PushPopup 사용
import ImportAlbumPopup from './ImportAlbumPopup';

import styleClasses from './css/MyPage.module.scss';

function ArchiveList() {
  const navigate  = useNavigate();
  const [uid, setUid]                         = useState(null);
  const [albums, setAlbums]                   = useState([]);
  const [isLoading, setIsLoading]             = useState(true);
  const [selectedAlbum, setSelectedAlbum]     = useState([]);
  const [selectedAlbums, setSelectedAlbums]   = useState([]);

  const [openImportPopup, setOpenImportPopuo] = useState(false);

  const [openPopup, setOpenPopup]             = useState(false);
  const [buttonLoading, setButtonLoading]     = useState(false);
  const [popupTitle, setPopupTitle]           = useState('');
  const [popupFunction, setPopupFunction]     = useState('');
  const [popupButtonText, setPopupButtonText] = useState('');

  const [openPushAlbumPopup, setOpenPushAlbumPopup] = useState(false);

  // 🔹 URL에서 가져오는 attribute 값 (released / unreleased)
  //const attribute = window.location.pathname.includes("/unreleased/") ? "unreleased" : "released";
  const { attribute } = useParams();

  const fetchAlbums = useCallback(async () => {
    if (!uid || !attribute) return; // uid 또는 attribute가 없으면 실행 중지
    try {
      // 🔹 Firestore 경로 설정 (`users_data/{userID}/{attribute}`)
      const albumsRef = collection(db, "users_data", uid, attribute);
      const snapshot = await getDocs(albumsRef);

      if (snapshot.empty) {
        setAlbums([]);
        // console.error(`No albums found in users_data/${uid}/${attribute}`);
        // setError("No albums found in data.");
        setIsLoading(false); // 여기서 로딩 상태를 false로 업데이트해야 함
        return;
      }

      const fetchedAlbums = snapshot.docs.map((albumDoc) => {
        const albumData = albumDoc.data();
        return {
          id: albumDoc.id,
          ...albumData,
          year: new Date(albumData.year),
          act: albumData.act || {}, // 🔹 act 필드가 없을 경우 빈 객체 할당
        };
      });

      // 🔹 연도순 정렬 (최신 앨범이 위로)
      fetchedAlbums.sort((a, b) => b.year - a.year);
      setAlbums(fetchedAlbums);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching albums:", error);
      
      setOpenPopup(true);
      setPopupTitle(`앨범을 불러오는 중 오류가 발생했습니다.`);
      setPopupButtonText('');
      setPopupFunction('');
    }
  }, [uid, attribute]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate('/login');
      } else {
        setUid(user.uid);
        fetchAlbums();
      }
    });
    return () => unsubscribe();
  }, [navigate, fetchAlbums]);

  // 체크박스 토글: 선택한 앨범 ID 추가/제거
  const handleCheckboxChange = (albumId) => {
    setSelectedAlbums((prevSelected) => {
      if (prevSelected.includes(albumId)) {
        return prevSelected.filter((id) => id !== albumId);
      } else {
        return [...prevSelected, albumId];
      }
    });
  };

  // 전체 선택/해제 함수
  const handleCheckAllAlbums = (event) => {
    const allChecked = event.target.checked;
    if (allChecked) {
      // 현재 불러온 모든 앨범의 id를 selectedAlbums에 저장
      setSelectedAlbums(albums.map(album => album.id));
    } else {
      setSelectedAlbums([]);
    }
  };

  const openPushAlbum = () => {
    if (selectedAlbums.length > 0) {
      setOpenPushAlbumPopup(true);
    } else {
      setOpenPopup(true);
      setPopupTitle(`앨범을 선택해주세요.`);
      setPopupButtonText('');
      setPopupFunction('');
    }
  };

  useEffect(() => {
    if (selectedAlbum.length) {
      setOpenPushAlbumPopup(true);
    }
  }, [selectedAlbum]);

  return (
    <>
      <SEO title='아카이브 목록' />
      <div className={styleClasses.myPage}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.title}>
            <h1>Archive</h1>
            <div className="commonIcon toolTip">
              <i className="questionBlack w20"></i>
              <div className="toolTipText bottom">
                <p>소유한 음원정보 관리 공간 <br />멜론, 유튜브 등 국내외 음원사이트에 발매한 음원(Released Albums), <br />사운드클라우드 등 미발매 음원(Unreleased)도 한번에 관리하세요.</p>
              </div>
            </div>
          </div>
          <div className={styleClasses.editContent}>
            <div className={styleClasses.leftContent}>
              <MyPageMenu />
            </div>
            <div className={styleClasses.rightContent}>
              <div className={styleClasses.content}>
                <div className={styleClasses.myArchive}>
                  <div className={styleClasses.topButtons}>
                    {/* 전체 선택 체크박스 추가 */}
                    <div className={styleClasses.checkBox}>
                      <div className='commonForm'>
                        <div className="formRow">
                          <div className="fieldBox checkBox">
                            <div className="eachBox">
                              <input
                                type="checkbox"
                                id="albumAll"
                                name="albumAll"
                                onChange={handleCheckAllAlbums}
                                checked={albums.length > 0 && selectedAlbums.length === albums.length}
                              />
                              <label htmlFor="albumAll">전체 선택</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* DeleteSelected 컴포넌트를 사용 */}
                    <DeleteSelected
                      selectedIDs={selectedAlbums}
                      documents={albums}
                      collectionPath={`users_data/${uid}/${attribute}`}
                      itemName="앨범"
                      subcollections={["tracks"]}
                      onDeleteSuccess={() => setSelectedAlbums([])}
                      fetchData={fetchAlbums}
                      setOpenPopup={ setOpenPopup }
                      setButtonLoading={ setButtonLoading }
                      setPopupTitle={ setPopupTitle }
                      setPopupFunction={ setPopupFunction }
                      setPopupButtonText={ setPopupButtonText }
                    />
                    <div className="commonButton fullwidth">
                      <Link to={`/my-page/archive/${attribute}/new`} className='black'>추가</Link>
                    </div>
                    <div className={`commonButton fullwidth ${ styleClasses.lastButton }`}>
                      {/*<Link to={`/my-page/archives/import`} className='black'>가져오기</Link>*/}
                      {/* <Link to={`/my-page/archive/${attribute}/push?albumId=${selectedAlbums.join(',')}`} className='black'>뮤지카드 적용</Link> */}
                      <button className='black' onClick={ openPushAlbum } >뮤지카드 적용</button>
                    </div>
                    <div className={`commonButton fullwidth ${ styleClasses.lastButton }`}>
                      {/* <Link to={`/my-page/archives/released/import`} className='black'>가져오기</Link> */}
                      <button className='black' onClick={ () => setOpenImportPopuo(true) }>가져오기</button>
                    </div>
                  </div>
                  <div className={styleClasses.topButtons}>
                  </div>
                  <div className={ styleClasses.albumCardList }>
                    {
                      isLoading
                      ?
                      <Loading />
                      :
                      albums.length === 0 
                      ?
                      (
                        <div className={`${ styleClasses.emptyList} `}>
                          <h1 dangerouslySetInnerHTML={{
                            __html: `${ attribute === 'released' ? 'Released' : 'Unreleased' } 앨범이 없습니다. <br/>앨범을 추가해주세요.`
                            }}
                          />
                        </div>
                      )
                      :
                      albums.map((album) => (
                        // 🔹 JSX Fragment (`<>...</>`)로 감싸기
                        <React.Fragment key={album.id}>
                          <div key={ album.id } className={ styleClasses.eachAlbumCard }>
                            <div className={ styleClasses.checkBox }>
                              <div className='commonForm'>
                                <div className="formRow">
                                  <div className="fieldBox checkBox">
                                    <input
                                    type="checkbox"
                                    id={`album${album.id}`}
                                    name='album'
                                    checked={selectedAlbums.includes(album.id)}
                                    onChange={() => handleCheckboxChange(album.id)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Link to={`/my-page/archive/${attribute}/${album.id}`} className={styleClasses.linkBox} onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/image_error.svg'; }}>
                              <img src={album.cover} alt={album.title} className="album-cover" />
                              <p className={styleClasses.title}>{album.title}</p>
                              <p className={styleClasses.date}>{album.year.toLocaleDateString()}</p>
                            </Link>
                            {/* act 필드와 함께 user uid와 attribute를 ActTags에 전달 */}
                            <ActTags 
                              act={album.act}
                              userUid={uid}
                              attribute={attribute}
                              albumID={ album.id }
                              fetchData={ fetchAlbums }
                              setSelectedItem={setSelectedAlbum}
                              setOpenPopup={ setOpenPopup }
                              setButtonLoading={ setButtonLoading }
                              setPopupTitle={ setPopupTitle }
                              setPopupFunction={ setPopupFunction }
                              setPopupButtonText={ setPopupButtonText }
                            />
                          </div>
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PushPopup
        open={ openPushAlbumPopup }
        setOpenPopup={ setOpenPushAlbumPopup }
        attribute={ attribute }
        selectedItem={ selectedAlbum }       // 카드 개별 선택
        setSelectedItem={ setSelectedAlbum }
        selectedItems={ selectedAlbums }     // 카드 여러개 선택
        categoryOptions={
          attribute === 'released'
            ? [
                { value: 'ownAlbums', label: '내 소유 앨범 (Musician Albums)' },
                { value: 'collaboAlbums', label: '협업 앨범 (Collaboration Albums)' },
              ]
            : []
        }
        defaultCategory={attribute === 'released' ? 'ownAlbums' : ''}
        fetchData={ fetchAlbums }
        //openAlertPopup={ openPopup }
        setOpenAlertPopup={ setOpenPopup }
        setPopupTitle={ setPopupTitle }
        setPopupButtonText={ setPopupButtonText }
        setPopupFunction={ setPopupFunction }
        clearSelectedItems={ setSelectedAlbums }
      />
      <ImportAlbumPopup
        open={ openImportPopup }
        setOpenPopup={ setOpenImportPopuo }
        fetchAlbums={ fetchAlbums }
      />
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } buttonLoading={ buttonLoading } />
    </>
  );
}

export default ArchiveList;